import { observer } from 'mobx-react-lite'
import React from 'react'
import { Image, Platform, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { ScrollView } from 'react-native-gesture-handler'

// import { NavigationProp, useNavigation } from '@react-navigation/native'

import { useStore } from '../../models'
// import { GameNavigation, GameRoutes } from '../../navigation/game-navigator'
import { moderateScale } from '../../styles/sizes'
import { fontFamily } from '../../theme/fontFamily'
import NavigationHeader from '../NavigationHeader/NavigationHeader'

// export type ObserverParamList = Record<keyof typeof GameRoutes, undefined>
// export type ObserverNavigation = NavigationProp<ObserverParamList>

export const ViewObserverButton = (prop: { disabled: boolean }) => {
  // const navigation = useNavigation<ObserverNavigation>()
  return (
    <TouchableOpacity
      disabled={prop.disabled}
      // hitSlop={{ top: 10, bottom: 20, left: 10, right: 20 }}
      onPress={() => {
        // navigation.navigate(GameRoutes.observerOverlay)
      }}
      style={{ padding: 2 }}
    >
      <Image
        style={{ height: moderateScale(16), width: 30, tintColor: prop.disabled ? 'gray' : 'white' }}
        source={require('../../assets/ObserverIcon.png')}
      />
    </TouchableOpacity>
  )
}

export const ObserverModal = observer(() => {
  const store = useStore()
  // const navigation = useNavigation<GameNavigation>()
  const observerPlayer = store.game.observersPlayerName
  return (
    <View style={[styles.background]}>
      <NavigationHeader
        title={'Observer'}
        customStyle={{ backgroundColor: 'rgb(5, 16, 45)', height: Platform.OS === 'ios' ? 85 : 72 }}
        navigate={() => {
          // navigation.navigate(GameRoutes.gameScreen)
        }}
        titleIcon={require('../../assets/ObserverIcon.png')}
        showEyeIcon={false}
      />
      <Text style={[styles.leaderBoardText]}>Observer List</Text>
      <ScrollView>
        {observerPlayer.map((item, index) => (
          <View style={styles.itemView} key={`ObserverPlayerItem${index}`}>
            <Text style={styles.item}>{item}</Text>
          </View>
        ))}
      </ScrollView>
    </View>
  )
})

const styles = StyleSheet.create({
  background: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#0D2063'
  },
  leaderBoardText: {
    fontSize: 20,
    color: '#FFBB0E',
    fontFamily: fontFamily.sfProDisplayBoldItalic,
    textTransform: 'uppercase',
    textAlign: 'center',
    marginBottom: 10,
    marginTop: 5
  },
  item: {
    fontSize: 26,
    fontFamily: fontFamily.sfProDisplayBold,
    color: 'white'
  },
  itemView: {
    paddingTop: 3
  }
})
